import { baseApi, qsmartApi } from '@/services/index';

const service = {
  read: (resource, payload) => baseApi.post(resource, payload),
  readQsmart: (resource, payload) => qsmartApi.post(resource, payload),
};

export default {
  namespaced: true,

  actions: {
    /** Petición para obtener las etiquetas de una evaluación. */
    read({ dispatch, rootGetters }, {
      dataItem, isUrlQsmart, resource, key,
    }) {
      return new Promise((resolve, reject) => {
        const payload = { ...dataItem };
        payload[key].eeDatos = [rootGetters['auth/state']];

        let notification;

        if (isUrlQsmart) {
          service
            .readQsmart(resource, payload)
            .then((response) => {
              const data = response.data[key];

              if (data.eeEstados[0].Returnid === 0) {
                resolve(data);
              } else if (data.eeEstados[0].Returnid === 98) {
                resolve([]);
              } else {
                notification = {
                  code: data.eeEstados[0].Returnid,
                  message: data.eeEstados[0].Estado,
                  timestamp: Date.now(),
                  type: 'error',
                };

                throw notification;
              }
            })
            .catch((error) => {
              if (error.type === undefined) {
                notification = {
                  code: error.name || undefined,
                  message: error.message,
                  timestamp: Date.now(),
                  type: 'error',
                };
              }

              dispatch('notification/create', notification, {
                root: true,
              });

              reject(notification);
            });
        } else {
          service
            .read(resource, payload)
            .then((response) => {
              const data = response.data[key];

              if (data.eeEstados[0].Returnid === 0) {
                resolve(data);
              } else if (data.eeEstados[0].Returnid === 98) {
                resolve([]);
              } else {
                notification = {
                  code: data.eeEstados[0].Returnid,
                  message: data.eeEstados[0].Estado,
                  timestamp: Date.now(),
                  type: 'error',
                };

                throw notification;
              }
            })
            .catch((error) => {
              if (error.type === undefined) {
                notification = {
                  code: error.name || undefined,
                  message: error.message,
                  timestamp: Date.now(),
                  type: 'error',
                };
              }

              dispatch('notification/create', notification, {
                root: true,
              });

              reject(notification);
            });
        }
      });
    },
  },
};
